// extracted by mini-css-extract-plugin
export var chip = "_rq-0";
export var icon = "_rq-1";
export var remove = "_rq-2";
export var removeIcon = "_rq-3";